import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { projectsKeys } from './projects.key';
import { toast } from '../../../components/Toast';
import { UpdateProject } from '@ansvar-sakerhet/api-client';

export function updateProject(projectId: string, data: UpdateProject) {
  const getApi = useApi();

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async () => {
      const api = await getApi();
      return await api.projectsUpdateProject(projectId, data);
    },
    onError: () => toast.error('Något gick fel'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: projectsKeys.all });
      toast.success('Projektet uppdaterat');
    },
  });

  return mutation;
}
